import React from 'react';
import { WrapperItem } from '../../components/wrapper-item';
import { Section } from '../../components/section';
import { paddingToString } from '../../utils/css-utils';
import { FooterBusinessDetails } from './footer-business-details';
import { FooterSocialIconsSection } from './footer-social-icons-section';
import { SiteTitleSection } from './footer-site-title';
import { FooterMobilePlacePromo } from './footer-mobile-place-promo';
export const SectionFooter = ({ section, cssClass, isRtl, onShareClick, onSiteTitleClick, }) => {
    const { businessDetails, siteTitle, socialButtons, mobilePlacePromo, textColor, showAd, } = section;
    const direction = isRtl ? 'rtl' : 'ltr';
    const columnInnerPadding = section.innerPadding;
    const isLastSection = !mobilePlacePromo.isVisible && !showAd;
    const footerPadding = {
        ...section.outerPadding,
        bottom: 0,
    };
    const bottomPadding = isLastSection ? columnInnerPadding?.bottom || 0 : 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(WrapperItem, null,
            React.createElement(Section, { backgroundColor: section.backgroundColor, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: isLastSection
                    ? paddingToString(section.outerPadding)
                    : paddingToString(footerPadding), direction: direction },
                React.createElement("div", { className: "footer-top-spacer", style: {
                        height: '10px',
                        padding: paddingToString({ ...columnInnerPadding, bottom: 0 }),
                    } }),
                React.createElement(FooterBusinessDetails, { ...businessDetails, textColor: textColor, fontFamily: section.fontFamily, isRtl: isRtl }),
                React.createElement(FooterSocialIconsSection, { ...socialButtons, section: section, isRtl: isRtl, onShareClick: onShareClick }),
                React.createElement(SiteTitleSection, { ...siteTitle, textColor: textColor, section: section, onSiteTitleClick: onSiteTitleClick }),
                React.createElement("div", { className: "footer-top-spacer", style: {
                        height: '10px',
                        padding: paddingToString({
                            ...columnInnerPadding,
                            top: 0,
                            bottom: bottomPadding,
                        }),
                    } }))),
        mobilePlacePromo.isVisible && (React.createElement(FooterMobilePlacePromo, { ...mobilePlacePromo, section: section, textColor: textColor, isRtl: isRtl }))));
};
//# sourceMappingURL=section-footer.js.map